import { render } from "./StockInOut.vue?vue&type=template&id=d83d8aa8&scoped=true"
import script from "./StockInOut.vue?vue&type=script&lang=js"
export * from "./StockInOut.vue?vue&type=script&lang=js"

import "./StockInOut.vue?vue&type=style&index=0&id=d83d8aa8&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83d8aa8"]])

export default __exports__